import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';
import type { HealthMetricType } from './useHealthmetrictypesWithMeasurements';

export type MeasurementType = {
  id: number;
  value: number;
  comment: string;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  healthmetrictypeId: number;
  healthMetricType?: HealthMetricType;
};

export type ConversationEntry = {
  question: string;
  answer: string;
  timestamp: string;
};

export type ConversationHistory = {
  conversation: ConversationEntry[];
};

export type MydayType = {
  id: number;
  date: string; // ISO date string
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  note: string;
  analysis: string;
  dayAnalysis?: string;
  historicalAnalysis?: string;
  description: string;
  day: number;
  month: number;
  year: number;
  type: string;
  status?: 'draft' | 'published';
  measurements?: MeasurementType[];
  file_count: number;
  file_ids: number[];
  aiConversations?: ConversationHistory | null;
};

export const useMyday = (id: string) => {
  return useQuery({
    queryKey: ['useMyday', id],
    queryFn: () => {
      if (!id || Number.isNaN(Number(id))) {
        return Promise.resolve(undefined);
      }
      return axios
        .get(`${envApiUrl}/mydays/find_day`, {
          headers: {
            'Content-Type': 'application/json',
            id,
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => response.data as MydayType)
        .catch((error) => {
          console.log('BBB: ', error);
          if (error.response) {
            console.log('useMyday Error: ', error.response.data);
            console.log(error.response.status);
          }
          if (error.response?.status === 403) {
            window.location.href = '/';
          }
          throw new Error(JSON.stringify(error.response?.data));
        });
    },
    enabled: Boolean(id) && !Number.isNaN(Number(id)),
  });
};
